<template lang="pug">
    div
        HowThisWorks
        CarDetails(:carList="sortedCars" ":selectedIndex"="bubble.userPref" @change="updateSelected" v-on="$listeners" :trips="trips" :bubble="bubble")
</template>

<script>
import CarDetails from "./CarDetails.vue";
import HowThisWorks from "./HowThisWorks";
export default {
  props: ["sortedCars", "bubble", "trips"],
  components: {
    CarDetails,
    HowThisWorks
  },
  computed: {
    validCarCount() {
      return this.sortedCars.length;
    }
  },
  methods: {
    updateSelected(car) {
      this.bubble.userPref = this.sortedCars.indexOf(car);
    }
  }
};
</script>